import React from "react";
import "./Dependents.css";
import Plus from "../../../../../assets/images/admin-dashboard/depinfoplus-outline.png";

const DependentInfo = () => {
  return (
    <div className="cltdetails__dependents_page">
      <div className="cltdetails__dependents_contentwrap">
        <div className="cltdetails__dependents_contentbox">
          <div className="cltdetails__dependents_cboxheader">
            <span>Dependent Info</span>
            <button className="cltdetails__dependents_adddepbtn">
              <img
                src={Plus}
                alt=""
                className="cltdetails__dependents_adddepbtnicn"
              />{" "}
              Add Dependent
            </button>
          </div>
          <div className="cltdetails__dependents_cboxbody">
            <div className="cltdetails__dependents_cboxbodyempty">
              No Dependents added for this client.
            </div>
          </div>
        </div>
      </div>
      <div className="cltdetails__dependents_contentwrap">
        <div className="cltdetails__dependents_bottombtns">
          <button className="cltdetails__dependents_bbtnfilled">Submit</button>
          <button className="cltdetails__dependents_bbtnoutlined">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DependentInfo;
